import { render, staticRenderFns } from "./SelectPrimary.vue?vue&type=template&id=5c0fcb18&scoped=true&"
import script from "./SelectPrimary.vue?vue&type=script&lang=js&"
export * from "./SelectPrimary.vue?vue&type=script&lang=js&"
import style0 from "./SelectPrimary.vue?vue&type=style&index=0&id=5c0fcb18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fcb18",
  null
  
)

export default component.exports